"use client";

import { useEffect, useState } from "react";

function handoffFromHash() {
  if (typeof window === "undefined") return "";
  return new URLSearchParams(window.location.hash.slice(1)).get("handoff")?.trim() || "";
}

export default function WorkMateCalLaunchPage() {
  const [message, setMessage] = useState("Opening WorkMate Cal…");

  useEffect(() => {
    const handoff = handoffFromHash();
    if (!handoff) {
      setMessage("Open WorkMate Cal from your WorkMate workspace.");
      return;
    }
    void fetch("/api/auth/csrf", { credentials: "same-origin" })
      .then(async (response) => {
        const payload = (await response.json()) as { csrfToken?: string };
        if (!response.ok || !payload.csrfToken) throw new Error("CSRF token unavailable");
        const form = document.createElement("form");
        form.method = "post";
        form.action = "/api/auth/callback/workmate-cal";
        for (const [name, value] of Object.entries({
          csrfToken: payload.csrfToken,
          handoff,
          callbackUrl: "/event-types",
        })) {
          const input = document.createElement("input");
          input.name = name;
          input.value = value;
          input.type = "hidden";
          form.appendChild(input);
        }
        document.body.appendChild(form);
        form.submit();
      })
      .catch(() => setMessage("WorkMate Cal access could not be confirmed."));
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-emphasis p-6 text-emphasis">
      {message}
    </main>
  );
}
